import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="about-descriptions-container">
      <div className="about-descriptions-placing">
        <span className="about-descriptions-title">Privacy Policy</span>
        <p className="about-descriptions-paragraph">
          Last Updated: 09/07/2025
        </p>

        <span className="about-descriptions-sub-title">1. Introduction</span>
        <p className="about-descriptions-paragraph-min">
          BeyondSchools Academy ("we," "our," or "us") operates the BeyondSchools Academy mobile application and digital learning platform in Tanzania. 
          We are committed to protecting your privacy and providing a secure learning environment for all users.
        </p>

        <span className="about-descriptions-sub-title">2. Information We Collect</span>
        <p className="about-descriptions-paragraph-min">2.1 Personal Information:</p>
        <p className="about-descriptions-paragraph-min">• Full name and contact details</p>
        <p className="about-descriptions-paragraph-min">• Grade level</p>
        {/* <p className="about-descriptions-paragraph-min">• Parent/guardian contact information (for minors)</p>
        <p className="about-descriptions-paragraph-min">• NECTA examination registration details</p>
        <p className="about-descriptions-paragraph-min">• Payment information for premium features</p> */}

        <p className="about-descriptions-paragraph-min">2.2 Learning Data:</p>
        <p className="about-descriptions-paragraph-min">• Academic progress and performance</p>
        <p className="about-descriptions-paragraph-min">• Quiz and test results</p>
        <p className="about-descriptions-paragraph-min">• Video viewing history</p>
        <p className="about-descriptions-paragraph-min">• Time spent on different subjects</p>
        <p className="about-descriptions-paragraph-min">• Device and usage information</p>

        <span className="about-descriptions-sub-title">3. How We Use Your Information</span>
        <p className="about-descriptions-paragraph-min">3.1 Educational Purposes:</p>
        <p className="about-descriptions-paragraph-min">• Personalize learning experiences</p>
        <p className="about-descriptions-paragraph-min">• Track academic progress</p>
        <p className="about-descriptions-paragraph-min">• Provide customized study recommendations</p>
        <p className="about-descriptions-paragraph-min">• Generate performance reports for students and parents</p>

        <p className="about-descriptions-paragraph-min">3.2 Platform Improvement:</p>
        <p className="about-descriptions-paragraph-min">• Enhance our learning materials</p>
        <p className="about-descriptions-paragraph-min">• Develop new features</p>
        <p className="about-descriptions-paragraph-min">• Improve user experience</p>
        <p className="about-descriptions-paragraph-min">• Conduct research on learning patterns</p>

        <p className="about-descriptions-paragraph-min">3.3 Communication:</p>
        <p className="about-descriptions-paragraph-min">• Send important updates about the platform</p>
        <p className="about-descriptions-paragraph-min">• Provide customer support</p>
        <p className="about-descriptions-paragraph-min">• Share educational content and notifications</p>

        <span className="about-descriptions-sub-title">4. Data Protection and Security</span>
        <p className="about-descriptions-paragraph-min">4.1 Security Measures:</p>
        <p className="about-descriptions-paragraph-min">• Encryption of data in transit and at rest</p>
        <p className="about-descriptions-paragraph-min">• Secure server infrastructure</p>
        <p className="about-descriptions-paragraph-min">• Regular security assessments</p>
        <p className="about-descriptions-paragraph-min">• Access controls and authentication</p>

        <p className="about-descriptions-paragraph-min">4.2 Data Retention:</p>
        <p className="about-descriptions-paragraph-min">
          We retain personal information only as long as necessary for educational purposes and as required by Tanzanian law.
        </p>

        <span className="about-descriptions-sub-title">5. Data Sharing and Disclosure</span>
        <p className="about-descriptions-paragraph-min">5.1 We Do Not Sell Data:</p>
        <p className="about-descriptions-paragraph-min">
          We do not sell, trade, or rent users' personal information to third parties.
        </p>

        <p className="about-descriptions-paragraph-min">5.2 Limited Sharing:</p>
        <p className="about-descriptions-paragraph-min">• With educational institutions for academic purposes (with consent)</p>
        <p className="about-descriptions-paragraph-min">• With parents/guardians of minor students</p>
        <p className="about-descriptions-paragraph-min">• With service providers under strict confidentiality agreements</p>
        <p className="about-descriptions-paragraph-min">• When required by Tanzanian law or legal process</p>

        <span className="about-descriptions-sub-title">6. Children's Privacy (Under 18 Years)</span>
        <p className="about-descriptions-paragraph-min">6.1 Parental Consent:</p>
        <p className="about-descriptions-paragraph-min">
          For students under 18, we require verifiable parental consent before collecting personal information.
        </p>

        <p className="about-descriptions-paragraph-min">6.2 Parental Rights:</p>
        <p className="about-descriptions-paragraph-min">Parents/guardians can:</p>
        <p className="about-descriptions-paragraph-min">• Review their child's personal information</p>
        <p className="about-descriptions-paragraph-min">• Request deletion of information</p>
        <p className="about-descriptions-paragraph-min">• Refuse further collection or use of information</p>
        <p className="about-descriptions-paragraph-min">• Withdraw consent at any time</p>

        <span className="about-descriptions-sub-title">7. User Rights and Choices</span>
        <p className="about-descriptions-paragraph-min">7.1 Your Rights:</p>
        <p className="about-descriptions-paragraph-min">• Access and review your personal information</p>
        <p className="about-descriptions-paragraph-min">• Correct inaccurate data</p>
        <p className="about-descriptions-paragraph-min">• Request deletion of your information</p>
        <p className="about-descriptions-paragraph-min">• Opt-out of certain data collections</p>
        <p className="about-descriptions-paragraph-min">• Export your learning data</p>

        <p className="about-descriptions-paragraph-min">7.2 How to Exercise Rights:</p>
        <p className="about-descriptions-paragraph-min">
          Contact our Data Protection Officer at: [Email Address]
        </p>

        <span className="about-descriptions-sub-title">8. Third-Party Services</span>
        <p className="about-descriptions-paragraph-min">
          Our platform may integrate with:
        </p>
        <p className="about-descriptions-paragraph-min">• Payment processors (e.g., Vodacom M-Pesa, Tigo Pesa)</p>
        <p className="about-descriptions-paragraph-min">• Cloud storage providers</p>
        <p className="about-descriptions-paragraph-min">• Analytics services (anonymized data only)</p>

        <span className="about-descriptions-sub-title">9. International Data Transfers</span>
        <p className="about-descriptions-paragraph-min">
          User data is primarily stored and processed within Tanzania. Any international transfers will comply with Tanzanian data protection regulations.
        </p>

        <span className="about-descriptions-sub-title">10. Changes to This Policy</span>
        <p className="about-descriptions-paragraph-min">
          We may update this policy periodically. Users will be notified of significant changes through the app or email.
        </p>

        <span className="about-descriptions-sub-title">11. Contact Information</span>
        <p className="about-descriptions-paragraph-min">
          Data Protection Officer:<br />
          Email: <a href="mailto:privacy@beyondschools.co.tz">privacy@beyondschools.co.tz</a><br />
          Phone: +255738 867 270<br />
          Address: BeyondSchools Academy,Victoria House, Dar es Salaam, Tanzania
        </p>

        <p className="about-descriptions-paragraph-min">
          Tanzania Commission for Science and Technology (COSTECH)<br />
          We comply with the Tanzania Data Protection Act and guidelines from COSTECH.
        </p>

        <span className="about-descriptions-sub-title">12. Consent</span>
        <p className="about-descriptions-paragraph-min">
          By using BeyondSchools Academy, you consent to this Privacy Policy and our Terms of Service.
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
